<template>
  <div name="new" class="inner">
    <innertopbar @close="close()">
      <template v-slot:breadcrumb>
       Latest News!
       
      </template>
       </innertopbar>


    
      <section class="mb-12 h-screen  bg-white rounded-2xl p-6 mt-6 mx-auto w-11/12">
        <iframe class="w-full h-screen" src="https://pepassport.co.uk/whats-new-with-the-pe-passport/?&allowQueryParams=true&immerseoption=true" frameborder='0' scrolling="yes"  allowfullscreen></iframe>

    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const TheNoticeBoard = () => import("@/components/TheNoticeBoard.vue");
const innertopbar = () => import("@/components/InnerTopBar.vue");

export default {
  name: "new",
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.$router.push("/");
    },
  },
  components: {
    TheNoticeBoard,
    innertopbar
  },
};
</script>

<style scoped>
</style>